import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { SSOApp } from "../../../../../typings/global";
import Strings from "@my-dld/assets/strings";
import { Redirect } from "react-router";
import { SSORegContext, Step } from "@my-dld/contexts/RegisterContext";
import queryString from "querystring";
import { SSOAppView } from "./index";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { LocaleUtil } from "@eres/core";
import { PickerItem } from "@my-dld/components/Picker";
import { LoginOptions } from "../../BaseLoginScreen";

interface Props extends RoutedViewProps {
	step: Step;
}

interface State {
	app?: SSOApp;
	apps: SSOApp[];
	error?: string;
	isSelector: boolean;
	isLoading?: boolean;
	option?: string;
	options?: PickerItem[];
}

class AppSelector extends Component<Props, State> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isSelector: this.props.match.isExact,
			apps: window.ssoApps.filter( x => x.signUpUrl != undefined && x.isLive === true && x.signUpMode !== "disabled" ),
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Props>, prevState: State ) {
		return {
			isSelector: nextProps.match.isExact,
		};
	}

	componentDidMount() {
		if ( this.props.location && this.props.location.search ) {
			const parsed = queryString.parse( this.props.location.search.substr( 1 ) );
			if ( parsed.appId && parsed.callback && typeof parsed.appId === "string" && typeof parsed.callback === "string" ) {
				const app = this.state.apps.find( x => x.id === parsed.appId );
				if ( app ) {
					if ( app.signUpMode === "sso" && app.signUpOptions == null ) {
						this.context.update!( { app: app, step: Step.eid } );
						this.props.history.push( `/sso/register/app/${ app.id }` );
					} else {
						requestAnimationFrame( () => {
							this.setState( { app: app } );
						} );
					}
				} else {
					this.setState( {
						error: Strings.no_application_found
					} );
				}
			}
		}
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( this.state.isSelector && this.context.step !== Step.app ) {
			this.context.update!( {
				step: Step.app,
			} );
		}
	}

	onRegister = () => {
		const { app, option, options } = this.state;
		let signUpMode = this.state.app!.signUpMode;
		if ( app && option != null && options != null ) {
			const opt = app.signUpOptions?.find( x => x.id === option );
			if ( opt ) {
				if ( opt.url ) {
					window.location.href = LocaleUtil.getLocalValue( opt.url );
				} else {
					this.context.update!( { app: this.state.app, step: Step.eid } );
					this.props.history.push( `/sso/register/app/${ this.state.app!.id }` );
				}
			}
		} else if ( signUpMode === "sso" ) {
			this.context.update!( { app: this.state.app, step: Step.eid } );
			this.props.history.push( `/sso/register/app/${ this.state.app!.id }` );
		} else if ( signUpMode === "app" ) {
			this.setState( {
				isLoading: true,
			} );
			window.location.href = LocaleUtil.getLocalValue( this.state.app!.signUpUrl! );
		}
	};

	onSelect = ( app?: SSOApp ) => {
		this.setState( { app: app } );
		if ( app?.signUpOptions != null && app.signUpOptions.length > 0 ) {
			let defaultOption: string | undefined = undefined;
			const opts: PickerItem[] = app.signUpOptions.map( o => {
				if ( o.isDefault ) defaultOption = o.id;
				return {
					id: o.id,
					value: o.name,
				};
			} );
			this.setState( {
				options: opts,
				option: defaultOption,
			} );
		} else {
			this.setState( { options: undefined, option: undefined } );
		}
	};
	onOptionChange = ( id: string ) => {
		this.setState( { option: id } );
	};
	canProceed = () => {
		const { app, option, options } = this.state;
		if ( app == null ) return false;
		if ( options && options.length > 0 && option == null )
			return false;
		return true;
	};

	render() {
		const { step } = this.context;
		const { options, option } = this.state;
		if ( step === Step.done ) return null;
		const isSelector = this.state.isSelector;
		const isDone = this.props.location.pathname.endsWith( "done" );
		if ( this.state.error ) {
			return <div>
				<h5 className={ "error" }>{ this.state.error }</h5>
			</div>;
		}
		if ( isSelector ) {
			return (
				<>
					<PickerInput
                        holder={ this }
                        label={ Strings.select_app_to_register }
						noLabel={ true }
						id={ "app" }
						toIdentifier={ item => item.id }
						formatter={ item => LocaleUtil.getLocalValue( item.name ) }
						items={ this.state.apps }
						onValueChange={ this.onSelect }
						required={ true }/>
					{ this.state.app &&
						<SSOAppView app={ this.state.app } extraClass={ "active" }/>
					}
					{ options != null && <>
						<LoginOptions
							items={ options } checkedId={ option ?? "" }
							onChange={ this.onOptionChange }/>
					</> }
                    <button
                        className="btn btn_1 btn_style1" disabled={!this.canProceed()}
                        onClick={this.onRegister}>
                        {(this.state.isLoading) ? <div className="relative spinner-border " role="status">
                            <span className="sr-only">{Strings.loading}</span>
                        </div> : Strings.proceed}</button>
				</>
			);
		} else {
			if ( this.state.app ) {
				let app = this.state.app;
				return <>
					<SSOAppView app={ app } extraClass={ "active" }/>
				</>;
			} else if ( this.context.app == null )
				return <Redirect to={ "/sso/register" }/>;
			return null;
		}
	}
}

export default AppSelector;
